import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode } from "vue"

import { computed, PropType } from "vue"

//region Props and Emits

type Icon = {
  name: string
  color?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDataPoint',
  props: {
  label: {
    required: true,
    type: String,
  },

  entityIcon: {
    type: Object as PropType<Icon>,
  },

  navigationIcon: {
    type: String,
  },

  clickable: {
    type: Boolean,
    default: false,
  },

  disable: {
    type: Boolean,
    default: false,
  },

  cardField: {
    type: Boolean,
    default: false,
  },

  hasIdentifier: {
    type: Boolean,
    default: false,
  },

  manager: {
    type: Boolean,
    default: false,
  },

  iconSpaceLarge: {
    type: Boolean,
    default: false,
  },

  valueEllipsis: {
    type: Number,
    default: 0,
    validator: (value: number) => {
      return value >= 0 && value <= 3
    },
  },
},
  emits: ["click"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const classes = computed(() => {
  return {
    "sfx-data-point__clickable": props.clickable,
    "sfx-data-point__card-field": props.cardField,
    "sfx-data-point__has-identifier": props.hasIdentifier,
    "sfx-data-point__manager": props.manager,
    "sfx-data-point__technician": !props.manager,
  }
})

const pointerClass = computed(() => {
  return {
    "cursor-pointer": props.clickable,
  }
})

const isHexColor = computed(() => props.entityIcon?.color && props.entityIcon?.color.includes("#"))
const iconStyle = computed(() =>
  isHexColor.value ? { color: props.entityIcon?.color + "!important" } : undefined
)
const iconColor = computed(() =>
  isHexColor.value ? undefined : props.entityIcon?.color || "navy-base"
)
const iconClass = computed(() => (props.iconSpaceLarge ? "q-pr-sm" : "q-pr-xs"))

const valueEllipsisClass = computed(() => {
  switch (props.valueEllipsis) {
    case 0:
    default:
      return
    case 1:
      return "ellipsis"
    case 2:
      return "ellipsis-2-lines"
    case 3:
      return "ellipsis-3-lines"
  }
})

const iconSize = computed(() => (props.manager ? "32px" : "24px"))

//endregion

//region Functions

function handleClick() {
  emit("click")
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_field = _resolveComponent("q-field")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createBlock(_component_q_item, {
    class: _normalizeClass(["sfx-data-point", classes.value]),
    clickable: props.clickable,
    onClick: handleClick,
    dense: "",
    disable: props.disable
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_field, {
        label: props.label,
        class: _normalizeClass(pointerClass.value),
        "stack-label": "",
        borderless: "",
        readonly: "",
        dense: ""
      }, _createSlots({
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["sfx-data-point__value", valueEllipsisClass.value])
          }, [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _createTextVNode("N/A")
            ])
          ], 2)
        ]),
        _: 2
      }, [
        (props.entityIcon || props.navigationIcon || _ctx.$slots.chip)
          ? {
              name: "append",
              fn: _withCtx(() => [
                (props.entityIcon)
                  ? (_openBlock(), _createBlock(_component_q_icon, {
                      key: 0,
                      class: _normalizeClass(iconClass.value),
                      name: props.entityIcon.name,
                      color: iconColor.value,
                      style: _normalizeStyle(iconStyle.value),
                      size: iconSize.value
                    }, null, 8, ["class", "name", "color", "style", "size"]))
                  : _createCommentVNode("", true),
                (props.navigationIcon)
                  ? (_openBlock(), _createBlock(_component_q_icon, {
                      key: 1,
                      class: "q-pr-xs",
                      name: props.navigationIcon,
                      size: iconSize.value,
                      color: "navy-base"
                    }, null, 8, ["name", "size"]))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "chip")
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["label", "class"])
    ]),
    _: 3
  }, 8, ["class", "clickable", "disable"]))
}
}

})